import { createReducer, on } from '@ngrx/store';
import { reportsInitialState, ReportsState } from './reports.state';
import { freeTrialApiActions, freeTrialPageActions } from './reports.actions';

export const reportsReducer = createReducer<ReportsState>(
  reportsInitialState,

  on(freeTrialPageActions.userClickedDownloadReport, (state): ReportsState => {
    return {
      ...state,
      freeTrialReport: {
        ...state.freeTrialReport,
        loading: true
      }
    };
  }),

  on(freeTrialApiActions.loadFreeTrialReportSuccess, (state): ReportsState => {
    return {
      ...state,
      freeTrialReport: {
        ...state.freeTrialReport,
        loading: false
      }
    };
  })
);
